import React from 'react';
import { styled } from '@linaria/react';
import { GenericErrorImage } from '../../../foundation/illustrations/GenericErrorImage';
import { Grid } from '../helpers/Grid';
const APPROXIMATE_HEADER_FOOTER_HEIGHT = 300;
interface Props {
  /** The body of the content */
  children: React.ReactChild | React.ReactChild[];
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The combined height in pixels of the header and footer components. This is used to calculate the min-height of the error message. */
  headerFooterHeight?: number;
  /** Whether the component should show the Illustration or not  */
  withIllustration?: boolean;
}
interface StyleProps {
  headerFooterHeight: number;
}
const _exp = /*#__PURE__*/() => Grid;
const _exp2 = /*#__PURE__*/() => ({
  headerFooterHeight
}) => headerFooterHeight;
const FlexItemsContainer = /*#__PURE__*/styled(_exp())({
  name: "FlexItemsContainer",
  class: "fbigcrx",
  propsAsIs: true,
  vars: {
    "fbigcrx-0": [_exp2(), "px"]
  }
});
export const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "iz9dc0x",
  propsAsIs: false
});
export const GenericError = ({
  children,
  headerFooterHeight = APPROXIMATE_HEADER_FOOTER_HEIGHT,
  withIllustration = false,
  className
}: Props) => <FlexItemsContainer container direction="column" alignItems="center" spacing="s000" headerFooterHeight={headerFooterHeight} className={className}>
    {children}
    {withIllustration && <ImageContainer>
        <GenericErrorImage />
      </ImageContainer>}
  </FlexItemsContainer>;

require("./GenericError.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GenericError.tsx");